<template>
    <div class="pagination" v-if="length">
      <button class="nav-button" :disabled="currentPage === 1" @click="$emit('selectPage', 1)">
        &#60;&#60;
      </button>
      <button class="nav-button" :disabled="currentPage === 1" @click="$emit('selectPage', currentPage - 1)">
        &#60;
      </button>
      <div v-for="(num, index) in numberArray" :key="index">
        <span v-if="num === -1"> ... </span>
        <button
          v-else
          class="page-button"
          :class="{ active: num === currentPage }"
          @click="$emit('selectPage', num)"
        >
          {{ num }}
        </button>
      </div>
      <button class="nav-button" :disabled="currentPage === totalPage" @click="$emit('selectPage', currentPage + 1)">
        &#62;
      </button>
      <button class="nav-button" :disabled="currentPage === totalPage" @click="$emit('selectPage', totalPage)">
        &#62;&#62;
      </button>
      <div class="goto-wrapper" v-if="totalPage > 10">
        <span class="goto-label">Go to:</span>
        <input
          type="number"
          class="goto-input"
          v-model.number="goToValue"
          @keyup.enter="handleGoTo"
          placeholder="e.g. 10"
        />
      </div>
    </div>
  </template>

<script>
export default {
  name: 'Pagination',
  props: {
    length: {
      type: Number,
      default: 0
    },
    pageNumber: {
      type: [Number, String],
      default: 1
    },
    perPage: {
      type: [Number, String],
      default: 10
    }
  },
  data () {
    return {
      goToValue: ''
    }
  },
  methods: {
    handleGoTo () {
      if (this.goToValue && this.goToValue >= 1 && this.goToValue <= this.totalPage) {
        this.$emit('selectPage', this.goToValue)
        this.goToValue = ''
      }
    }
  },
  computed: {
    currentPage () {
      return Number(this.pageNumber) || 1
    },
    totalPage () {
      return (
        Math.ceil(this.length / this.perPage)
      )
    },
    numberArray () {
      const totalButtonCount = this.totalPage
      if (totalButtonCount <= 3) {
        return [...Array(totalButtonCount).keys()].map((i) => i + 1)
      }
      if (this.currentPage === 1) {
        return [1, 2, -1, totalButtonCount]
      }
      if (this.currentPage === 2) {
        return [1, 2, 3, -1, totalButtonCount]
      }
      if (this.currentPage === totalButtonCount) {
        return [1, -1, totalButtonCount - 1, totalButtonCount]
      }
      if (this.currentPage === totalButtonCount - 1) {
        return [1, -1, totalButtonCount - 2, totalButtonCount - 1, totalButtonCount]
      }
      return [-1, this.currentPage - 1, this.currentPage, this.currentPage + 1, -1]
    }
  }
}
</script>

  <style scoped lang="scss">
  .pagination {
    display: flex;
    width: fit-content;
    align-items: center;
    gap: 5px;
    padding-top: 15px;
  }

  .page-button, .nav-button {
    min-width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: white;
    cursor: pointer;
    font-size: var(--text-s);
    font-weight: 500;
    transition: all 0.3s ease;
  }

  .page-button:hover, .nav-button:hover {
    background: #CFD8DC;
  }

  .page-button.active {
    background: #CFD8DC;
    // color: white;
    // border-color: black;
  }

  .nav-button {
    background: #f5f5f5;
  }

  .nav-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .ellipsis {
    padding: 0 10px;
    font-size: var(--text-l);
  }

  .goto-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 10px;
  }

  .goto-label {
    font-size: var(--text-s);
    font-weight: 500;
    color: #333;
  }

  .goto-input {
    width: 60px;
    height: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 0 6px;
    font-size: var(--text-s);
    text-align: center;
    outline: none;
    transition: border-color 0.3s;
  }

  .goto-input:focus {
    border-color: #999;
  }

  /* hide arrows in number input */
  .goto-input::-webkit-outer-spin-button,
  .goto-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .goto-input[type=number] {
    -moz-appearance: textfield;
  }
  </style>
